import React, { useState } from 'react';
import { Popover, Button, TextField, Tooltip, IconButton } from '@mui/material';
import axios from 'axios';
import { LiaPlusCircleSolid } from 'react-icons/lia';
import { TagService } from '../../../services/tags';

const TagPopover: React.FC<{ update(): void}> = ({ update }) => {
  
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [tagName, setTagName] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setTagName('');
    setError(null);
  };

  const tag = new TagService();
  
  const handleSave = async () => {
    if (!tagName.trim()) {
      setError('O nome da tag não pode estar vazio.');
      return;
    }

    try {
      const response = await tag.post({ name: tagName });
      console.log('Tag salva com sucesso:', response);
      update();
      handleClose();
    } catch (error) {
      console.error('Erro ao salvar a tag:', error);
      setError('Ocorreu um erro ao salvar a tag.');
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'tag-popover' : undefined;

  return (
    <>
        <Tooltip title="Nova Tag">
            <IconButton onClick={handleOpen}>
                <LiaPlusCircleSolid />
            </IconButton>
        </Tooltip>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
            }}
        >
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '8px', width: '250px' }}>
            <TextField
                label="Nome da Tag"
                variant="outlined"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                error={!!error}
                helperText={error}
            />
            
            <Button variant="contained" color="warning" onClick={handleSave}>
                Confirmar
            </Button>
            </div>
        </Popover>
    </>
  );
};

export default TagPopover;
